/* eslint-disable react/destructuring-assignment */
import React from 'react';
import PropTypes from 'prop-types';
import NavItem from './components/NavItem';
import NavMenuButton from './components/NavMenuButton';
import NavItemTooltip from './components/NavItemTooltip';
import NavItemProfile from './components/NavItemProfile';
// import ProfileStatic from './components/ProfileTooltip/Profile.static';
import NavItemCart from './components/NavItemCart';
import Async from '../../../../../Async';
import { isBelowDesktop } from '../../../../../../shared/breakpoints';

import NavStatic from './Nav.static';

/* Style */
import t from '../../../../../../css/global.module.css';
import s from './nav.module.css';
import glossaryTagQA from '../../../../../../tracking/qa/glossaryTagQA';
import { truncateString } from '../../../../truncateString';
import { publicRuntimeConfig } from '../../../../../../server/services/configService';


class Nav extends React.Component {
  componentDidMount() {
    if (window.convertSpan) {
      window.convertSpan();
    }
  }

  /* eslint-disable-next-line no-unused-vars */
  componentDidUpdate(prevProps, prevState, snapshot) {
    if (window.convertSpan) {
      window.convertSpan();
    }
  }

  render() {
    const {
      menu,
      personalized,
      helpLink,
      conversationIsActive,
      merchantCenterIsActive,
      merchantCenterBetaTesters,
      sellHomeRedirectionIsActive,
    } = this.props;

    let nbProducts = 0;
    if (personalized.cart) {
      // eslint-disable-next-line prefer-destructuring
      nbProducts = personalized.cart.nbProducts;
    }
    if (personalized.cartNotifications) {
      // eslint-disable-next-line prefer-destructuring
      nbProducts = personalized.cartNotifications.nbProducts;
    }
    let actionsTotalCount = 0;
    if (personalized.profile) {
      // eslint-disable-next-line prefer-destructuring
      actionsTotalCount = personalized.profile.actionsTotalCount;
    }
    let priceClubStatusLink = NavStatic.priceclub.link;

    if (personalized.priceClub) {
      if (personalized.priceClub.isSubscribed) {
        priceClubStatusLink = NavStatic.priceclub.isMemberLink;
      }
    }
    let profileUrl;
    const mcEnabledForUser = personalized?.profile?.isPro
      && (merchantCenterIsActive || merchantCenterBetaTesters.includes(personalized?.profile?.userId));
    const mcEnabled = merchantCenterIsActive || merchantCenterBetaTesters.length;

    if (mcEnabledForUser) profileUrl = NavStatic.profile.merchantCenterLink;
    else if (mcEnabled) profileUrl = NavStatic.profile.connectLink;
    else profileUrl = NavStatic.profile.link;

    return (
      <nav className={`${s.nav} ${t['bg-white']} ${t.flex} ${t['justify-around']}`}>
        { /*  Menu Button */
          /* Chrome fired a onMouseEnter/onMouseLeave on devtool mobile env
           * So we pass onHover only for desktop */
        }
        <NavMenuButton
          labels={NavStatic.menu.labels}
          isOpen={menu.isOpen}
          onClick={menu.onClick}
          onHoverIn={isBelowDesktop() ? null : menu.onHoverIn}
          onHoverOut={isBelowDesktop() ? null : menu.onHoverOut}
        />
        {/*  Sales  */}
        <NavItemTooltip
          content={() => (
            <Async
              promise={
                import(
                  /* webpackChunkName: "SalesTooltip" */
                  /* webpackMode: "lazy" */
                  // eslint-disable-next-line function-paren-newline
                  './components/SalesTooltip')
              }
              classNameLoader={s.loader}
              sellHomeRedirectionIsActive={sellHomeRedirectionIsActive}
            />
          )}
          data={{
            labels: {
              large: NavStatic.sales.labels.large,
              small: NavStatic.sales.labels.small,
            },
            icon: NavStatic.sales.icon,
            link: sellHomeRedirectionIsActive ? NavStatic.sales.sellHomeLink : NavStatic.sales.link,
          }}
          qaTagName={glossaryTagQA.header.toolTip.sell}
          displayLink
        />
        {/*  Help  */}
        <NavItem
          hideOn="Landscape"
          data={{
            labels: {
              large: NavStatic.help.labels.large,
              small: NavStatic.help.labels.small,
            },
            icon: NavStatic.help.icon,
            link: helpLink,
          }}
          qaTagName={glossaryTagQA.header.toolTip.help}
        />
        {/*  PriceClub  */}
        <NavItemTooltip
          hideOn="tablet"
          content={() => (
            <Async
              promise={
                import(
                  /* webpackChunkName: "PriceClubTooltip" */
                  /* webpackMode: "lazy" */
                  // eslint-disable-next-line function-paren-newline
                  './components/PriceClubTooltip')
              }
              classNameLoader={s.loader}
            />
          )}
          data={{
            hideOn: 'Tablet',
            customClassNav: 'priceClub',
            // ...priceclub
            labels: {
              icon: {
                max: NavStatic.priceclub.labels.icon.max,
                desktop: NavStatic.priceclub.labels.icon.max,
              },
            },
            link: priceClubStatusLink,
          }}
          qaTagName={glossaryTagQA.header.toolTip.priceclub}
        />
        {/*  Favorites  */}
        <NavItemTooltip
          content={() => (
            <Async
              promise={
                import(
                  /* webpackChunkName: "FavoritesTooltip" */
                  /* webpackMode: "lazy" */
                  // eslint-disable-next-line function-paren-newline
                  './components/FavoritesTooltip')
              }
              classNameLoader={s.loader}
            />
          )}
          // data={{ ...favorites }}
          data={{
            labels: {
              large: NavStatic.favorites.labels.large,
              small: NavStatic.favorites.labels.small,
            },
            icon: NavStatic.favorites.icon,
            link: NavStatic.favorites.link,
          }}
          qaTagName={glossaryTagQA.header.toolTip.fav}
        />

        {/*  Profile  */}
        <NavItemProfile
          content={() => (
            <Async
              promise={
                import(
                  /* webpackChunkName: "ProfileTooltip" */
                  /* webpackMode: "lazy" */
                  // eslint-disable-next-line function-paren-newline
                  './components/ProfileTooltip')
              }
              classNameLoader={s.loader}
              conversationIsActive={conversationIsActive}
              merchantCenterIsActive={merchantCenterIsActive}
              merchantCenterBetaTesters={merchantCenterBetaTesters}
              sellHomeRedirectionIsActive={sellHomeRedirectionIsActive}
            />
          )}
          data={{
            labels: {
              large: (
                personalized
                && personalized.profile
              ) ? truncateString(personalized.profile.firstNameOrPseudo,
                  publicRuntimeConfig.header.firstNameOrPseudoMaxLength) : NavStatic.profile.labels.large,
              small: NavStatic.profile.labels.small,
            },
            icon: NavStatic.profile.icon,
            link: profileUrl,
          }}
          qaTagName={glossaryTagQA.header.toolTip.account}
          actionsTotalCount={actionsTotalCount}
        />

        {/*  Cart  */}
        <NavItemCart
          content={() => (
            <Async
              promise={
                import(
                  /* webpackChunkName: "CartTooltip" */
                  /* webpackMode: "lazy" */
                  // eslint-disable-next-line function-paren-newline
                  './components/CartTooltipCtn')
              }
              classNameLoader={s.loader}
            />
          )}
          data={{
            labels: {
              default: NavStatic.cart.labels.default,
            },
            icon: NavStatic.cart.icon,
            link: NavStatic.cart.link,
          }}
          // data={{ ...cart }}
          alignTooltipRight
          qaTagName={glossaryTagQA.header.toolTip.cart}
          nbProducts={nbProducts}
        />
      </nav>
    );
  }
}


Nav.propTypes = {
  personalized: PropTypes.shape({
    cart: PropTypes.shape({
      nbProducts: PropTypes.number,
    }),
    cartNotifications: PropTypes.shape({
      nbProducts: PropTypes.number,
    }),
    profile: PropTypes.shape({
      actionsTotalCount: PropTypes.number,
      firstNameOrPseudo: PropTypes.string,
      isPro: PropTypes.bool,
    }),
    priceClub: PropTypes.shape({
      isSubscribed: PropTypes.bool,
    }),
  }),
  menu: PropTypes.objectOf(PropTypes.oneOfType([PropTypes.bool, PropTypes.func, PropTypes.object]))
    .isRequired,
  helpLink: PropTypes.string,
  conversationIsActive: PropTypes.bool.isRequired,
  merchantCenterIsActive: PropTypes.bool.isRequired,
  merchantCenterBetaTesters: PropTypes.arrayOf(PropTypes.string).isRequired,
  sellHomeRedirectionIsActive: PropTypes.bool.isRequired,
};
Nav.defaultProps = {
  personalized: {},
  helpLink: NavStatic.help.link,
};

Nav.contextTypes = {
  obfuscationIsActive: PropTypes.bool,
  universe: PropTypes.string,
};

export default Nav;
